import { DatePipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'weightPipe',
  pure: false
})
export class WeightPipe implements PipeTransform {

  constructor(private lang: string, private digits?: string) {
  }

  transform(value: any): any {
    const decimalPipe: DecimalPipe = new DecimalPipe(this.lang);
    if (value !== null && value !== undefined && value !== '') {
      return decimalPipe.transform(value, this.digits);
    } else {
      return value;
    }
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/ubi-core/pipes/WeightPipe.ts